import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { Cohort3CustomerBanner as BannerType } from './banner/index.tsx';

const Cohort3Banner = lazyAfterPaint<typeof BannerType>(
	() =>
		import(/* webpackChunkName: "async-banner-eoc-cohort3-customers" */ './banner').then(
			(module) => module.Cohort3CustomerBanner,
		),
	// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
	{ entryFsSsrLiftImportToModule: true, includeInShellOnlySsrBundle: true },
);

export const Cohort3BannerAsync = () => (
	<Placeholder name="async-banner-eoc-cohort3-customers" fallback={null}>
		<Cohort3Banner />
	</Placeholder>
);
